export function logoutMobileUser() {
  window.flutter_inappwebview?.callHandler("onLogout");
}
